var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUniversityIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6170_11529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 9.35968H15.2448V8.50796C15.2446 8.38356 15.1774 8.26891 15.069 8.20796L10.3448 5.55279V4.20106H11.2793V4.71486C11.2793 4.90529 11.4337 5.05968 11.6241 5.05968H14.4414C14.6318 5.0596 14.7861 4.90516 14.7861 4.71473C14.7861 4.67481 14.7791 4.6352 14.7655 4.59762L14.4828 3.79417L14.769 3.00796C14.8337 2.82887 14.741 2.63119 14.5619 2.56645C14.5244 2.55287 14.4848 2.54593 14.4448 2.54589H13.1621V2.04589C13.1621 1.85546 13.0077 1.70106 12.8172 1.70106H10.3448V1.28037C10.3448 1.08994 10.1904 0.935547 10 0.935547C9.80957 0.935547 9.65517 1.08994 9.65517 1.28037V5.55279L4.93103 8.20451C4.82259 8.26546 4.75539 8.38012 4.75517 8.50451V9.35624H0.344828C0.154397 9.35624 0 9.51063 0 9.70106V18.7218C0 18.9122 0.154397 19.0666 0.344828 19.0666H19.6552C19.8456 19.0666 20 18.9122 20 18.7218V9.70451C20 9.51408 19.8456 9.35968 19.6552 9.35968ZM13.1621 3.85624L13.1483 3.84244V3.24934H13.9345L13.7931 3.69072C13.7649 3.76753 13.7649 3.85184 13.7931 3.92865L13.9552 4.37003H11.969V4.20106H12.8172C13.0077 4.20106 13.1621 4.04667 13.1621 3.85624ZM10.3448 2.39072H12.4724V2.90451V3.51141H10.3448V2.39072ZM4.75517 18.3769H0.689655V10.0493H4.75517V18.3769ZM9.65517 18.3769H7.84483V14.439H9.65517V18.3769ZM12.1552 18.3769H10.3448V14.439H12.1552V18.3769ZM14.569 18.3769H12.8448V14.0942C12.8448 13.9037 12.6904 13.7493 12.5 13.7493H7.5C7.30957 13.7493 7.15517 13.9037 7.15517 14.0942V18.3769H5.43103V8.72175L10 6.14934L14.5552 8.70796L14.569 9.70106V18.3769ZM19.3103 18.3769H15.2448V10.0493H19.3103V18.3769Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 7.20215C9.20196 7.20404 8.55566 7.85189 8.55566 8.65042C8.55756 9.4484 9.20597 10.0937 10.0039 10.0918C10.8019 10.0899 11.4472 9.4415 11.4453 8.64353C11.4434 7.84693 10.7971 7.20215 10.0005 7.20215ZM10.0005 9.40215C9.58342 9.40025 9.24687 9.0606 9.24877 8.64353C9.25066 8.22917 9.5861 7.8937 10.0005 7.8918C10.4181 7.8937 10.7557 8.2328 10.7557 8.65042H10.7591C10.7572 9.06749 10.4176 9.40405 10.0005 9.40215Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21114 10.8057H1.52148V12.185H2.21114V10.8057Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91036 10.8057H3.2207V12.185H3.91036V10.8057Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8588 10.8057H6.47949V11.4953H7.8588V10.8057Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6889 10.8057H9.30957V11.4953H10.6889V10.8057Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5199 10.8057H12.1406V11.4953H13.5199V10.8057Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85783 12.4131H6.47852V13.1027H7.85783V12.4131Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6889 12.4131H9.30957V13.1027H10.6889V12.4131Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5199 12.4131H12.1406V13.1027H13.5199V12.4131Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21016 13.5205H1.52051V14.8998H2.21016V13.5205Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91036 13.5205H3.2207V14.8998H3.91036V13.5205Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21114 16.2373H1.52148V17.6166H2.21114V16.2373Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91036 16.2373H3.2207V17.6166H3.91036V16.2373Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7795 10.8057H16.0898V12.185H16.7795V10.8057Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4797 10.8057H17.79V12.185H18.4797V10.8057Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7795 13.5205H16.0898V14.8998H16.7795V13.5205Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4797 13.5205H17.79V14.8998H18.4797V13.5205Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7785 16.2373H16.0889V17.6166H16.7785V16.2373Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4797 16.2373H17.79V17.6166H18.4797V16.2373Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6170_11529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityIconBlue);
export default __webpack_public_path__ + "static/media/university_icon_blue.4705164b9b4a8ab5e4335351ecb27664.svg";
export { ForwardRef as ReactComponent };